import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function ShopAdmin() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [selectedId, setSelectedId] = useState("");
  const [allShops, setAllShops] = useState([]);
  const [allAdmins, setAllAdmins] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [adhar, setAdhar] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [altPhoneNumber, setAltPhoneNumber] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  function getData() {
    axios
      .get(
        `${Baseurl.baseurl6}/go-grocery/admin/get-all-grocery-admin`
      )
      .then((res) => {
        setSpinner(false);
        setAllAdmins(res.data.details);
      });
  }
  function getShops() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/shop/get-all-shop-details`)
      .then((res) => {
        if (res.data.status) {
          setAllShops(res.data.details);
        } else {
          swal(
            "Oops",
            "please create the shops to add Admin",
            "error",
            {
              button: "Done",
              timer: 2000,
            }
          );
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
    getShops();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function addCategory() {
    let catFields = {
        name:name,
        phone:phoneNumber,
        aPhone:altPhoneNumber,
        email:email,
        aadhaar:adhar,
        shopId:selectedId
      };
      axios
        .post(
          `${Baseurl.baseurl6}/go-grocery/admin/create-grocery-admin`,
          catFields
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      handleClose();
  }
  function updateCategory() {
    let catFields = {
        name:name,
        phone:phoneNumber,
        aPhone:altPhoneNumber,
        email:email,
        aadhaar:adhar,
        shopId:selectedId
    };
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/admin/update-grocery-admin/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function deleteAdmin() {
    axios
      .delete(
        `${Baseurl.baseurl6}/go-grocery/admin/delete-grocery-admin-details-by-id/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setCatId(val._id);
    setUpdateStatus(true);

    setName(val.Name);
    setPhoneNumber(val.Phone)
    setAltPhoneNumber(val.AlternatePhone)
    setEmail(val.Email)
    setSelectedId(val.ShopId._id)
    setAdhar(val.Aadhaar)
    setShow(true);
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Admin</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Admin ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteAdmin();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
            <div className="col-sm-2 mt-2">
                    <label>
                      Shops<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <select
                     value={selectedId}
                      required
                      className="form-control"
                      id="val-skill"
                      name="val-skill"
                      onChange={(event) => {
                        setSelectedId(event.target.value);
                      }}
                    >
                      <option selected="true" disabled="disabled"></option>
                      {allShops &&
                        allShops.map((val) => (
                          <option value={val._id}>{val.Name}</option>
                        ))}
                    </select>
                  </div>

              <div className="col-sm-2 mt-2">
                <label>
                  Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={name}
                  type="text"
                  className="form-control"
                  placeholder="enter Name"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-3">
            <div className="col-sm-2 mt-2">
                <label>
                  Phone Number<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={phoneNumber}
                  type="text"
                  className="form-control"
                  placeholder="enter Phone Number"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                  maxLength={10}
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                Alternate Phone Number<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={altPhoneNumber}
                  type="text"
                  className="form-control"
                  placeholder="enter alternate phone number"
                  onChange={(e) => setAltPhoneNumber(e.target.value)}
                  required
                  maxLength={10}
                />
              </div>
           </div>
           <div className="row mt-3">
            <div className="col-sm-2 mt-2">
                <label>
                  Email<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={email}
                  type="text"
                  className="form-control"
                  placeholder="enter email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
               Adhar Number<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={adhar}
                  type="text"
                  className="form-control"
                  placeholder="enter adhar number"
                  onChange={(e) => setAdhar(e.target.value)}
                  required
                  maxLength={12}
                />
              </div>
           </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
           
          </div>
          <button
            onClick={() => {
                setShow(true);
          setUpdateStatus(false);
          setName("");
          setPhoneNumber('')
          setAltPhoneNumber('')
          setEmail('')
          setSelectedId('')
          setAdhar('')
            
            }}
            className="btn btn-primary"
          >
            Add Admin
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Shop Name</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>
                    <th>
                      <strong>Alternate Phone</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allAdmins &&
                    allAdmins.map((val, key) => (
                      <tr key={val._id}>
                        <td>{val.Name}</td>
                        <td>{val.ShopId.Name}</td>
                        <td>{val.Phone}</td>
                        <td>{val.AlternatePhone}</td>
                        <td>{val.Email}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allAdmins && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero Admins
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default ShopAdmin;
